/* eslint-disable no-param-reassign */
import Raven from 'raven-js';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import axios from '@/components/helpers/axiosConfig';
import sleep from '@/components/helpers/sleep';

Vue.use(Vuex);

const catchError = (error) => {
  Raven.captureException(error);
  return error;
};

export default new Vuex.Store({
  plugins: [
    createPersistedState({ storage: window.sessionStorage }),
  ],
  state: {
    conversions: [],
    workerQueue: {},
  },
  mutations: {
    addConversion(state, conversion) {
      const conversionIndex = state.conversions.findIndex((item => item.id === conversion.id));
      if (conversionIndex < 0) {
        state.conversions.unshift(conversion);
      }
    },
    removeConversion(state, conversionID) {
      const conversionIndex = state.conversions.findIndex((item => item.id === conversionID));
      state.conversions.splice(conversionIndex, 1);
    },
    updateConversion(state, conversion) {
      const conversionIndex = state.conversions.findIndex((item => item.id === conversion.id));
      if (conversionIndex >= 0) {
        state.conversions.splice(conversionIndex, 1, conversion);
      } else {
        // TODO: conversion is missing. Should this be logged or something?
      }
    },
    updateQueueStat(state, queue) {
      state.workerQueue = queue;
    },
  },
  getters: {
    getConversions(state) {
      return state.conversions;
    },
    getConversion: state => (id) => {
      const conversionIndex = state.conversions.findIndex((item => item.id === id));
      if (conversionIndex >= 0) {
        return state.conversions[conversionIndex];
      }
      return null;
    },
    queueStat(state) {
      return state.workerQueue;
    },
  },
  actions: {
    fetchConversion({ commit, dispatch }, id) {
      dispatch('fetchQueueStat');
      const requestURL = `/api/converter/${id}/`;
      axios.get(requestURL)
        .then((response) => {
          const conversion = response.data;
          if (conversion.finished) {
            commit('updateConversion', conversion);
          } else {
            sleep(5000).then(() => {
              dispatch('fetchConversion', id);
            });
          }
        })
        .catch((e) => {
          if (e.response.status === 404) {
            commit('removeConversion', id);
          } else {
            const error = `Unknown error occured. Please try again.
            If the Problem persists, please let us know. Original error: ${e}`;
            const fakeConversion = {
              error,
              id,
            };
            commit('updateConversion', fakeConversion);
          }
        });
    },
    removeConversion({ commit, dispatch }, id) {
      dispatch('fetchQueueStat');
      return axios.delete(`/api/converter/${id}/`)
        .then(() => {
          commit('removeConversion', id);
        })
        .catch((e) => {
          catchError(e);
          commit('removeConversion', id);
        });
    },
    fetchQueueStat({ commit }) {
      const requestURL = '/api/rq_stats/default/';
      axios.get(requestURL)
        .then((response) => {
          const queueStats = response.data;
          commit('updateQueueStat', queueStats);
        })
        .catch(catchError);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js